import { Polyline, Postprocessing } from '@editor/services/PolylineExtraction/interfaces'
import { dist, polylineLength } from '@editor/services/PolylineExtraction/utils/math'

export interface NoiseFilterConfig {
  /**
   * Minimum length between start and end points to keep the polyline
   */
  minEndToEndLength: number

  /**
   * Minimum total polyline length to keep the polyline
   */
  minTotalLength: number
}

export class NoiseFilter extends Postprocessing {
  protected config: Required<NoiseFilterConfig>

  constructor(config: NoiseFilterConfig) {
    super()
    this.config = config
  }

  // need to fulfill abstract method
  // eslint-disable-next-line class-methods-use-this
  getName(): string {
    return 'Noise Filter'
  }

  run(polylines: Polyline[]): Polyline[] {
    const { minEndToEndLength, minTotalLength } = this.config

    this.logger?.log(`    🧹 Noise filtering: minLength=${(minEndToEndLength * 1000).toFixed(1)}mm`)

    const filtered = polylines.filter((polyline) => {
      // Guard against polylines with fewer than 2 points
      if (polyline.length < 2) return false

      const endToEndDist = dist(polyline[0], polyline[polyline.length - 1])
      const totalLength = polylineLength(polyline)

      // If either length is too small, filter out
      if (totalLength < 1e-6 || endToEndDist < 1e-16) return false

      // Keep only if both lengths exceed thresholds
      return endToEndDist >= minEndToEndLength && totalLength >= minTotalLength
    })

    this.logger?.log(`    ✅ Noise filtering: ${polylines.length} → ${filtered.length} polylines`)
    return filtered
  }
}
